import { Component, OnInit } from '@angular/core';
import { DateHelper } from 'src/app/helpers/date.helper';
import { GetContentsRequest } from 'src/app/models/getContentsRequest';
import { ProfileService } from '../../services/profile.service';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.page.html',
  styleUrls: ['./content-list.page.scss'],
})
export class ContentListPage implements OnInit {

  results = [];
  title = '';

  pagina = 0;
  state = '';
  canShowMore = true;
  limit = 4;

  constructor(
    private contentService: ContentService,
    private route: ActivatedRoute,
    private profileService: ProfileService
  ) { }

  ngOnInit() {

    this.route.params.subscribe( params => {
      this.state = params.filter;
      params.filter === 'week' ? this.getThisWeek() : this.getPriority();
      params.filter === 'week' ? this.title = 'Eventos de la semana' : this.title = 'Pensado para vos';
    })
  }

  getMore() {
    this.pagina ++;
    this.state === 'week' ? this.getThisWeek() : this.getPriority();    
  }

  getThisWeek(){
    this.contentService.getContents({
      dateFrom: DateHelper.toString(DateHelper.today()), 
      dateTo: DateHelper.toString(DateHelper.sevenDays()),
      orderBy: 'PINNED',
      offset: this.pagina,
      limit: this.limit,
      onlyCurrentSchedules: true
    } as GetContentsRequest)
        .subscribe( (resp: []) => {
          console.log( resp );
          resp.forEach( x => this.results.push( x ) )
          resp.length === this.limit ? this.canShowMore = true : this.canShowMore = false;
        })
  }

  getPriority(){
    this.contentService.getContents({
      dateFrom: DateHelper.toString(new Date()),
      orderBy: 'INTEREST',
      limit: this.limit,
      offset: this.pagina,
      profileId: parseInt(this.profileService.profile.id)
    } as GetContentsRequest)
        .subscribe( (resp: []) => {
          console.log( resp );
          resp.forEach( x => this.results.push( x ) )
          resp.length === this.limit ? this.canShowMore = true : this.canShowMore = false;
        })
  }

}
